import { Alignment, BoxModelConstraint, ColumnComposition, ColumnCompositions, ColumnPanel, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { CellData } from '@ddt-web/data-service';

export class RowUtils {

	/*
	 * This class has generic methods for building row panels from column compositions. 
	 * Each row panel has a title and description on the lhs, and some content on the rhs. 
	 */
	public static buildRows(columnCompositions: ColumnCompositions, rowName: string, subsectionName: string, textClasses?: string[], constraints?: Partial<BoxModelConstraint>): Array<RowPanel> {
		const rows: Array<RowPanel> = [];
		columnCompositions.body.forEach((configs: Array<ColumnComposition>) => {
			const cell: CellData = Array.isArray(configs[0].cells) ? configs[0].cells[0] : configs[0].cells;
			const row: RowPanel = new RowPanel(
				rowName,
				configs.map((config: ColumnComposition, configIndex: number) => {
					if (configIndex === 0) {
						return new ColumnPanel(
							subsectionName,
							[
								new StaticParagraphComponent(`PDF_${cell.config.label.key}_TITLE`, cell.formattedValue, {}, {}, textClasses),
								new StaticParagraphComponent(`PDF_${cell.config.label.key}_SUBTITLE`, '')
							],
							{ proportion: config.widthProportion, ...constraints },
							config.horizontalAlignment,
							Alignment.Vertical.Middle
						);
					}
					return config.renderer.render();
				}),
				{ marginBottom: 5 },
				Alignment.Horizontal.Left,
				Alignment.Vertical.Top
			);

			rows.push(row);
		});

		return rows;
	}

}
